<template>
  <div class="metadata-config">
    <div class="content">
      <div class="nav">
        <el-button type="primary" @click="parseData">解析</el-button>
        <el-button type="warning" @click="cacheBoxWithCellAndTemp">更新缓存</el-button>
        <el-button type="primary" @click="saveAllData">保存全部</el-button>
      </div>
      <el-table class="tbl" :data="tableData" border height="540" @selection-change="handleSelectionChange" :highlight-current-row="true" v-loading="loading">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="emsName" label="ems名称" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.emsName }}
          </template>
        </el-table-column>
        <el-table-column prop="sn" label="sn" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.sn }}
          </template>
        </el-table-column>
        <el-table-column label="单簇内插箱数" >
          <template slot-scope="scope">
            <el-input v-model="scope.row.boxQuantity" type="number" @input="initzero(scope.row)" clearable placeholder="请输入单簇内插箱数"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="boxRowQuantity" label="插箱内列数" show-overflow-tooltip>
          <template  slot-scope="scope">
            <el-input v-model="scope.row.boxRowQuantity" type="number" clearable placeholder="请输入插箱内列数"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="cellQuantity" label="簇内电芯数" show-overflow-tooltip>
          <template  slot-scope="scope">
            <el-input v-model="scope.row.cellQuantity" type="number" clearable placeholder="请输入簇内电芯数"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="tempQuantity" label="簇内温度数" show-overflow-tooltip>
          <template  slot-scope="scope">
            <el-input v-model="scope.row.tempQuantity" type="number" clearable placeholder="请输入簇内温度数"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="submitForm(row)">保存</el-button>
            <el-button type="text" size="small" @click="copy(row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import PROJECTAPI from '@/api/project';
  import GROUPAPI from '@/api/group';
  export default {
    props: {
      projectName: {
        type: [String, Number]
      },
      projectId: {
        type: [String, Number]
      },
      isType: {
        type: [String, Number]
      }
    },
    data() {
      return {
        loading:false,
        title: '',
        labelPosition: 'right',
        dialogVisible: false,
        tableData: [],
        form: {},
        multipleSelection: []
      };
    },
    components: {},
    created() {
      this.searchModelDataConfigList()
    },
    watch: {},
    methods: {
      initzero(row){

      },
      handleSelectionChange(val){
        this.multipleSelection = val
      },
      //复制
      copy(row){
        if(this.multipleSelection.length>0){
          this.tableData.map(item=>{
            for(let i=0;i<this.multipleSelection.length;i++){
              if(item.sn==this.multipleSelection[i].sn){
                item.boxQuantity =row.boxQuantity
                item.boxRowQuantity=row.boxRowQuantity
                item.cellQuantity=row.cellQuantity
                item.tempQuantity=row.tempQuantity
                break;
              }
            }
            return item
          })
        }else{
          this.$message.warning('请选择被复制记录')
        }
      },
      //查询列表
      async searchModelDataConfigList() {
        let res = await PROJECTAPI.searchModelDataConfigList({
          projectId: this.projectId
        });
        if (res.data.code = 200) {
          this.tableData = JSON.parse(JSON.stringify(res.data.data))
        }
      },
      //新增项目模型
      async addModelDataConfig(row){
        let res = await PROJECTAPI.addModelDataConfig(row);
        if (res.data.code = 200) {
          this.searchModelDataConfigList()
          this.$message.success('操作成功')
        }else{
          this.$message.error('操作失败')
        }
        this.loading = false
      },
      //修改项目模型
      async updateModelDataConfig(row){
        let res = await PROJECTAPI.updateModelDataConfig(row);
        if (res.data.code = 200) {
          this.searchModelDataConfigList()
          this.$message.success('操作成功')
        }else{
          this.$message.error('操作失败')
        }
        this.loading = false
      },
      //提交表单
      submitForm(row) {
        let params = {
          projectId:row.projectId,
          emsId:row.emsId,
          boxQuantity:parseFloat(row.boxQuantity),
          boxRowQuantity:parseFloat(row.boxRowQuantity),
          cellQuantity:parseFloat(row.cellQuantity),
          tempQuantity:parseFloat(row.tempQuantity)
        }
        this.loading = true
        if(row.id=='0'){
          this.addModelDataConfig(params)
        }else{
          params.id = row.id
          this.updateModelDataConfig(params)
        }
      },
      //重置
      resetForm() {
        this.$refs['ruleForm'].resetFields();
      },
      //解析
      async parseData() {
        this.loading = true
        let res = await PROJECTAPI.analysisProjectDataGeneratingMetadata({projectId:this.projectId})
        if(res.data.code==200){
          this.$message.success('操作成功')
        }else{
          this.$message.error('操作失败')
        }
        this.loading = false
      },
      //保存全部
      saveAllData() {
        this.loading = true
        PROJECTAPI.batchSaveModelDataConfigList(this.tableData).then(res=>{
          if(res.data.code==200){
            this.$message.success('操作成功')
          }else{
            this.$message.error('操作失败')
          }
          this.loading = false
        }).catch(error=>{
          this.loading = false
        })

      },
      //更新缓存
      cacheBoxWithCellAndTemp(){
        this.loading = true
        PROJECTAPI.cacheBoxWithCellAndTemp({projectId:this.projectId}).then(res=>{
          if(res.data.code==200){
            this.searchModelDataConfigList()
            this.$message.success('操作成功')
          }else{
            this.$message.error('操作失败')
          }
          this.loading = false
        }).catch(error=>{
          this.loading = false
        })
      }
    }
  };
</script>

<style lang="scss">
  .metadata-config {
    .content {
      padding: 30px;

      .nav {
        float: right;
        margin-bottom: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/project/metadataConfig.vue